class AboutPageLifesaver {
    constructor() {
        this.aboutPageLifesaver = document.querySelector(".about-page-lifesaver");
        this.headings = document.querySelectorAll(".sticky-heading");
        this.events();
    }

    events() {
        if (this.aboutPageLifesaver) {
            // Set up media query for devices over 1024px
            const mediaQueryLarge = window.matchMedia('(min-width: 1024px)');

            // Set rootMargin options for each media query
            const rootMarginSmall = '-60% 0px -40% 0px';
            const rootMarginLarge = '-10% 0px -40% 0px';

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const id = entry.target.id;
                        // Select the image that has the same ID as the heading followed by "-img"
                        const image = document.querySelector(`#${id}-img`);
                        // Add the "visible" class to the image
                        image.classList.add("visible");
                        // Remove the "visible" class from the image that was previously visible
                        const previousImage = document.querySelector(".about-page-lifesaver .visible:not(#" + id + "-img)");
                        if (previousImage) {
                            previousImage.classList.remove("visible");
                        }
                    }
                });

            }, {
                root: null,
                rootMargin: mediaQueryLarge.matches ? rootMarginLarge : rootMarginSmall,
                threshold: 0
            });

            this.headings.forEach((heading) => {
                observer.observe(heading);
            }
        );
    }
}
}

export default AboutPageLifesaver;